// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"0739d6ce","271":"a084072c","360":"72a6064f","395":"b0f4cb54","404":"077121cc","419":"e8dfe002","453":"8b899ff3","707":"a13a2490","992":"ab71c6df"}[chunkId] + ".chunk.js";
};